﻿import {ValidationMessage} from '../validationMessage';
import {ValidateResult} from '../validateResult';

export interface IValidator {
    validate(value: any, propertyName: string, propertydisplayName: string, errorMessage: string, param: any): ValidateResult;
}

export class ValidatorTuple {
    constructor(public validator: IValidator, public arg: any) {}
}
   